import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {CustomField, ICustomField} from 'app/blocks/model/custom-field.model';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldService extends EntityCrudService<ICustomField> {
    constructor(http: HttpClient) {
        super(http, Resource.CUSTOM_FIELDS, (obj?) => new CustomField(obj));
    }
}
